

export var baseStrapiUrl = "https://castropolcms.upintelligence.es"
//export var baseStrapiUrl = "http://localhost:1337"
//export var baseStrapiUrl = "http://172.16.5.13:1337"

export var baseWebUrl = "https://web.upintelligence.es//"
//export var baseWebUrl = "http://localhost:8080/"

export var baseBackUrl = "https://opendatacastropol.upintelligence.es"